<div
  role="alert"
  class="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center text-slate-900"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="h-16 w-16 opacity-60"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
  </svg>
  <h1 class="text-2xl font-semibold">{{ 'notFound.title' | translate }}</h1>
  <p class="max-w-sm text-base opacity-70">{{ 'notFound.hint' | translate }}</p>
</div>
